/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量19
 * @export
 * @interface Col19
 */
export interface Col19 {
}

/**
 * Check if a given object implements the Col19 interface.
 */
export function instanceOfCol19(value: object): value is Col19 {
    return true;
}

export function Col19FromJSON(json: any): Col19 {
    return Col19FromJSONTyped(json, false);
}

export function Col19FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col19 {
    return json;
}

export function Col19ToJSON(json: any): Col19 {
    return Col19ToJSONTyped(json, false);
}

export function Col19ToJSONTyped(value?: Col19 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

